import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ErrorNotice, useAction } from "../components/ui";
import { api, type Company, type Job } from "../lib/api";
import { JobForm } from "./JobForm";
import { JobRow } from "./Jobs";

/** Jobs at this client, plus "new job" with the fee pre-filled from the terms. */
export function CompanyJobs({ company }: { company: Company }) {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState<Job[]>([]);
  const [adding, setAdding] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const load = useAction();

  const reload = useCallback(
    () => load.run(async () => {
        setJobs((await api.jobs({ companyId: company.id })).jobs);
        setLoaded(true);
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [company.id],
  );
  useEffect(() => void reload(), [reload]);

  return (
    <section className="section" aria-labelledby="jobs-h">
      <div className="section-head">
        <h2 id="jobs-h" className="label">
          Jobs
        </h2>
        <button type="button" className="link-btn" onClick={() => setAdding((v) => !v)}>
          {adding ? "Cancel" : "+ New job"}
        </button>
      </div>
      <ErrorNotice error={load.error} />
      {adding && (
        <JobForm
          companyId={company.id}
          submitLabel="Create job"
          onCancel={() => setAdding(false)}
          onSubmit={async (input) => {
            const { job } = await api.createJob(company.id, input);
            navigate(`/jobs/${job.id}`);
          }}
        />
      )}
      <ol className="index">
        {jobs.map((j, i) => (
          <JobRow key={j.id} job={j} index={i} showCompany={false} showOwner />
        ))}
        {loaded && jobs.length === 0 && !adding && (
          <li>
            <span className="empty">No jobs here yet.</span>
          </li>
        )}
      </ol>
    </section>
  );
}
